module.exports = __webpack_public_path__ + "assets/img/icon_community.bf1c39b7.svg";